
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <form [formGroup]="assetsDialogForm" (ngSubmit)="submit()">
      <div class="modal-header">
        <h4 class="modal-title">Remove Assets</h4>
        <button class="close" type="button" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col-sm-6">
            <label class="required" for="removeProductNumber">Product Number</label>
            <input class="form-control" id="removeProductNumber" type="text" formControlName="standaloneProductNumber" name="standaloneProductNumber">
          </div>
          <div class="form-group col-sm-6">
            <label class="required" for="removeModelName">Product Description</label>
            <input class="form-control" id="removeModelName" type="text" formControlName="model" name="model">
          </div>
          <div class="form-group col-sm-6">
            <label class="required" for="removeDisposition">Disposition</label>
            <select class="form-control" id="removeDisposition" formControlName="disposition" name="removeDisposition">
              <option *ngFor="let disposition of dispositions" [ngValue]="disposition">{{disposition.disposition_text}}</option>
            </select>
          </div>
          <div class="form-group col-sm-6">
            <label class="required" for="modifyQuantity">Quantity</label>
            <input class="form-control" id="modifyQuantity" type="number" formControlName="quantity" name="quantity" [max]="maxQuantity" min="1" (change)="changeBulkOrder()">
          </div>
          <div class="form-group col-sm-6" *ngIf="assetsDialogForm.value.quantity === 1">
            <label for="modifyMapId">Map ID</label>
            <input class="form-control" id="modifyMapId" type="text" formControlName="floorMapId" name="floorMapId" maxlength="60">
          </div>
          <div class="form-group col-sm-6" *ngIf="assetsDialogForm.value.quantity === 1">
            <label for="modifyGrid">Grid</label>
            <input class="form-control" id="modifyGrid" type="text" formControlName="grid" name="grid" maxlength="60">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyBuilding">Building</label>
            <input class="form-control" id="modifyBuilding" type="text" formControlName="building" name="building" maxlength="60">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyFloor">Floor</label>
            <input class="form-control" id="modifyFloor" type="text" formControlName="floor" name="floor" maxlength="60">
          </div>
          <div class="form-group col-sm-6">
            <label for="modifyDepartment">Department</label>
            <input class="form-control" id="modifyDepartment" type="text" formControlName="department" name="department" maxlength="60">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
        <button class="btn btn-primary" type="submit" [disabled]="!assetsDialogForm.valid">Save</button><span *ngIf="assetsDialogForm">{{assetsDialogForm.errors}}</span>
      </div>
    </form>
  </div>
</div>